import React from 'react';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';
import ParticiPantElement from './ParticiPantElement';

const Participant = props => {
  const { element, elementStyle } = props;
  const { formSettings, formItemSettings, settings } = element.data;
  const { visible } = settings;
  const { defaultValue = [] } = formItemSettings;
  const { rules = [] } = formSettings;
  const ruleProps: any = {};
  if (rules.length > 0) {
    ruleProps.rules = [{ required: rules[0].required }]
  }

  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
      {...ruleProps}
    >
      <ParticiPantElement element={element} {...props} />
    </FormItem>
  );
};

export default Participant;
